module.exports = __webpack_public_path__ + "static/media/icon-info.372bf471.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-info.svg
// module id = 357
// module chunks = 0